// This component is used as a placeholder for functionalities that have been disabled

import React from "react";
import SimpleBreadcrumb from "components/SimpleBreadcrumb";
import { Col, Container, Row } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { ActionButton } from "@gelsenwasser/react";
import { BsArrowLeft } from "react-icons/bs";

const FunctionDisabled: React.VFC = () => {
  const history = useHistory();
  const handlePreviousStep = () => {
    history.push("/");
  };

  return (
    <>
      <Container>
        <SimpleBreadcrumb subPageTitle={"Nicht vorhanden"} />
      </Container>
      <Container>Diese Funktion steht nicht mehr zur Verfügung.</Container>
      <Container>
        <Row>
          <Col>
            <ActionButton caption="Zurück" icon={BsArrowLeft} onClick={handlePreviousStep} />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default FunctionDisabled;
